import { ChangePartner } from './ChangePartner';

export class ChangePartnerImage extends ChangePartner {
  type: string = 'Partner.ChangeImageUrl';
}
